<h2 mat-dialog-title>{{ 'MAINTENANCES.ARCHIVE_ALERT.ALERT_TITLE_ARCHIVE' | translate }}</h2>

<mat-dialog-content>
  <p [innerHTML]="'MAINTENANCES.ARCHIVE_ALERT.ALERT_ARCHIVE' | translate"></p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close cdkFocusInitial>
    {{ 'MAINTENANCES.ARCHIVE_ALERT.CANCEL' | translate }}
  </button>

  <button mat-button mat-dialog-close="true">
    {{ 'MAINTENANCES.ARCHIVE_ALERT.ARCHIVE' | translate }}
  </button>
</mat-dialog-actions>
